import BaseCollection from '@/collections/BaseCollection';

export default class CrmServiceCollection extends BaseCollection {
  constructor(){
    super();
  }

  routes() {
    const model = (new (this.model())());
    
    return {
      fetch: `${process.env.VUE_APP_CRM_REPOSITORY_URL}/api/v1/${model.modelName()}`,
    }
  }
}
